import type { AnalyticsRouter } from '@app/packages/analytics/router'

import { createThunk } from '@app/store/thunk'

export function getAnalyticsRouter() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<AnalyticsRouter>(AnalyticsRouterSymbol))
}
export function setAnalyticsRouter(value: AnalyticsRouter) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(AnalyticsRouterSymbol, value))
}

const AnalyticsRouterSymbol = Symbol('AnalyticsRouter')
